import { useQueryClient } from '@tanstack/vue-query'

const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_SIZE)

const MEAL_SIZE_QUERY_KEY = 'meal-sizes' as const
const mealSizeQueryKey = { ...useQueryKeyFactory(MEAL_SIZE_QUERY_KEY) }
export const apiMealSizes = {
	fetchDietMealSizes: async (
		search: string | undefined,
		type: 'meal' | 'prep_meal' | undefined,
		page: number = 1,
		perPage: number = 25,
	) => {
		const fetchFn = async () => {
			const { data, meta } = await apiCommon<IDietMealSize[]>(`${groupPrefix}`, {
				method: 'GET',
				...createQuery({ page, perPage }, { name: search, meal_kind: type }),
			})
			return { data: data.map(d => DietMealSize(d)), meta }
		}

		const config = () => ({
			queryKey: mealSizeQueryKey.list({
				type,
				page,
				search,
				perPage,
			}),
			queryFn: async () => await fetchFn(),
		})

		const queryClient = useQueryClient()

		const query = config()

		return (
			queryClient.getQueryData<IApiResponseModel<IDietMealSizeModel[]>>(query.queryKey) ??
			(await queryClient.fetchQuery(query))
		)
	},
}
